import { createFileRoute } from "@tanstack/react-router";

import { PraxaOverviewSurface } from "../components/praxa/PraxaOverviewSurface";

export const Route = createFileRoute("/w/$workspaceId/overview")({
  component: PraxaOverviewRoute,
});

function PraxaOverviewRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaOverviewSurface workspaceId={workspaceId} />;
}
